/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {NEGRITA, TESTIMONIOS} from "../../../Constantes";
import linea from '../../../Recursos/Iconos/ic_raya.svg'
import '@splidejs/react-splide/css';
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {theme} from "../../../Tema";
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import {KeyboardArrowLeft, KeyboardArrowRight} from '@mui/icons-material'
import {useRef} from "react";


const Home_Testimonios = () => {
    const refe = useRef(null);

    const siguiente = () => {
        refe.current.go('>')
    }
    const anterior = () => {
        refe.current.go('<')
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: 48,
                                color: theme.palette.primary.main
                            }}>TESTIMONIOS</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <img src={linea} width={40} height={'auto'} alt={'linea'}/>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <Splide
                                ref={refe}
                                aria-label="My Favorite Images"
                                style={{width: '100%'}}
                                options={{
                                    autoplay: false,
                                    perPage: 1,
                                    arrows: false,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'false',
                                    noDrag: true,
                                    type: 'loop',
                                    gap: 40,
                                    interval: 5000,
                                    speed: 5000,
                                }}
                            >

                                {TESTIMONIOS.map((it, index) => {
                                    return (
                                        <SplideSlide>
                                            <Tarjeta_Testimonio item={it}/>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: 'space-between', alignItems: 'center', mt: -20}}>

                            <IconButton
                                onClick={() => anterior()}
                                sx={{
                                    backgroundColor: theme.palette.secondary.main,
                                    width: 48,
                                    height: 48,
                                    "&:hover": {
                                        backgroundColor: theme.palette.primary.main,
                                    }
                                }}>
                                <KeyboardArrowLeft sx={{fill: '#fff'}}/>
                            </IconButton>

                            <IconButton
                                onClick={() => siguiente()}
                                sx={{
                                    backgroundColor: theme.palette.secondary.main,
                                    width: 48,
                                    height: 48,
                                    "&:hover": {
                                        backgroundColor: theme.palette.primary.main,
                                    }
                                }}>
                                <KeyboardArrowRight sx={{fill: '#fff'}}/>
                            </IconButton>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Testimonios